// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2QJjT","header":"PatientQuestionnaire_header__20Kgt","info":"PatientQuestionnaire_info__2XuJX"};